import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CookieBanner: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const consent = localStorage.getItem('cookie-consent');
        if (!consent) {
            const timer = setTimeout(() => setIsVisible(true), 2000);
            return () => clearTimeout(timer);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem('cookie-consent', 'accepted');
        setIsVisible(false);
    };

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:max-w-md z-[100]"
                >
                    <div className="glass-card-platinum p-6 rounded-[2rem] border-primary/20 shadow-2xl relative overflow-hidden">
                        <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 blur-3xl -mr-16 -mt-16 rounded-full" />

                        <div className="flex gap-4 relative z-10">
                            <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                                <ShieldCheck className="w-6 h-6 text-primary" />
                            </div>

                            <div className="flex-1">
                                <h3 className="font-bold text-lg mb-2">Cookies y Privacidad</h3>
                                <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed mb-4">
                                    Utilizamos cookies para asegurar que obtengas la mejor experiencia en nuestra web y para analizar el tráfico de forma anónima.
                                </p>

                                <div className="flex flex-col sm:flex-row gap-3">
                                    <button
                                        onClick={acceptCookies}
                                        aria-label="Aceptar todas las cookies"
                                        className="px-6 py-3 bg-[#0F172A] text-white rounded-xl font-bold text-sm hover:bg-slate-800 transition-all shadow-glow-sm min-h-[48px]"
                                    >
                                        Aceptar Todo
                                    </button>
                                    <button
                                        onClick={() => navigate('/privacy')}
                                        aria-label="Leer más sobre política de cookies y privacidad"
                                        className="px-6 py-3 glass-card-platinum rounded-xl font-bold text-sm border-slate-200 dark:border-slate-800 hover:bg-slate-100 dark:hover:bg-slate-800 transition-all text-center min-h-[48px]"
                                    >
                                        Leer Más
                                    </button>
                                </div>
                            </div>

                            <button
                                onClick={() => setIsVisible(false)}
                                aria-label="Cerrar aviso de cookies"
                                className="absolute top-0 right-0 p-2 text-slate-400 hover:text-slate-600 dark:hover:text-white transition-colors min-w-[48px] min-h-[48px] flex items-center justify-center"
                            >
                                <X className="w-5 h-5" />
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CookieBanner;
